const message =  {
    matdatil: 'Competition Details',
    time:'Competition Schedule',
    baoming:'Registration Time',
    address: 'Competition Venue',
    porpa: "Competition Rules",
    serch: "Registration Inquiry",
    jion: "Join the Team",
    term: "Register with Team Code",
    go:"-"
  }
export default message;